import { Card, ControlledTextField } from 'modules/shared/components';
import ControlledFileUpload from 'modules/shared/components/form/ControlledFileUpload';
import { FormProvider, useForm } from 'react-hook-form';

/**
 * Task submission form (file + required comment).
 *
 * @param {Object} props
 * @param {number} props.version Submission index (r0, r1, r2...)
 * @param {Function} props.onSubmit Called with form payload on submit
 * @param {Function} props.onCancel Called when form is cancelled
 */
export default function TaskSubmissionForm({ version, onSubmit, onCancel }) {
  const methods = useForm({
    defaultValues: {
      comment: '',
      document: null,
    },
    mode: 'onSubmit',
  });

  const {
    handleSubmit,
    watch,
    formState: { isSubmitting, errors },
  } = methods;
  const document = watch('document');

  const submitHandler = (values) =>
    onSubmit({
      version,
      comment: values.comment.trim(),
      document: values.document,
    });

  return (
    <Card borderVariant='default' colorVariant='primary'>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(submitHandler)} className='column gap-2'>
          <span className='font-md'>R{version}</span>

          <div className='row row--end'>
            <ControlledFileUpload
              name='document'
              buttonText='Upload file'
              autoUpload={false}
              rules={{ required: 'Please choose a file' }}
            />
          </div>
          {document?.file?.name && <span className='text-sm self-end'>{document.file.name}</span>}
          {errors.document && (
            <span className='text-sm self-end' style={{ color: 'var(--error, #d32f2f)' }}>
              {String(errors.document.message)}
            </span>
          )}

          <ControlledTextField
            name='comment'
            label='Comment'
            fullWidth
            required
            orientation='row'
            placeholder='Enter comment'
          />

          <div className='row row--end'>
            <button
              type='button'
              className='btn outlined-btn'
              onClick={onCancel}
              disabled={isSubmitting}
            >
              Cancel
            </button>

            <button type='submit' className='btn cta-btn' disabled={isSubmitting}>
              Save
            </button>
          </div>
          {isSubmitting && <div className='loading-indicator'>Saving...</div>}
        </form>
      </FormProvider>
    </Card>
  );
}
